<div class="container-card flex-direction-column justify-between">
  <div class="margin-left-6">
    <span class="font-14 weight-700">{{ tarefa?.descricao ?? '--' }}</span>
  </div>
  <div class="flex-direction-column gap-5 margin-left-6">
    <span class="font-12 weight-600" [style.color]="'#C4C4C4'">ULT. TIME</span>
    <span class="font-12 weight-600" [style.color]="'var(--primary)'">{{ tarefa?.dataFim ? (tarefa?.dataFim | date: 'dd/MM/yyyy - HH:mm') : (tarefa?.dataUltimoSucesso | date: 'dd/MM/yyyy - HH:mm')  }}</span>
  </div>
  <div class="width-100 flex center-center">
    <div class="card-status flex center-center" [ngClass]="{
            'status-concluido' : tarefa?.status === 'CONCLUIDO',
            'status-em-andamento' : tarefa?.status === 'EM_ANDAMENTO',
            'status-erro' : tarefa?.status === 'ERRO'
          }">
      <span class="font-14 weight-700" [style.color]="'#fff'">{{ getStatus() }}</span>
    </div>
  </div>
</div>
